<template>
  <div
    class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 header m-0"
  >
    <div class="md-layout">
      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 header truncated_header mb-4"
      >
        <div class="md-layout">
          <div
            class="md-layout-item md-medium-size-100 md-size-100 truncated_header2"
          >
            <div class="md-layout md-alignment-center">
              <div
                class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-60 p-0 report-header"
              >
                <h1 class="title-h4-formatting">
                  {{ "Sole Proprietorship Financial Report" + ": " }}
                </h1>
                <ul>
                  <li>
                    <p class="sub-title-formatting">
                      <i class="md-icon md-icon-dark-blue">business_center</i
                      >Industry:
                    </p>
                    <p>
                      [{{ parseFloat(this.headerData.bznaics) }}]
                      {{ this.headerData.industry }}
                    </p>
                  </li>
                  <li>
                    <p class="sub-title-formatting">
                      <i class="md-icon md-icon-dark-blue">apartment</i>Sector:
                    </p>
                    <p>{{ this.headerData.sector }}</p>
                  </li>
                  <li>
                    <p class="sub-title-formatting">
                      <i class="md-icon md-icon-dark-blue">place</i>Market Area:
                    </p>
                    <p>{{ this.headerData.area }}</p>
                  </li>
                  <li>
                    <p class="sub-title-formatting">
                      <i class="md-icon md-icon-dark-blue">equalizer</i>Sales
                      Class:
                    </p>
                    <p>{{ this.headerData.sales_class }}</p>
                  </li>
                </ul>
              </div>
              <div
                class="md-layout-item md-medium-size-100 md-xsmall-size-50 md-size-40 button-box"
              >
                <md-button
                  class="md-info access-button pdf_btn"
                  @click="feedback"
                >
                  <md-icon>comment</md-icon>Product Feedback
                </md-button>
                <md-button
                  target="_blank"
                  class="md-info access-button pdf_btn"
                  @click="generateReport"
                >
                  <md-icon class="ml-5">picture_as_pdf</md-icon>Download PDF
                </md-button>
                <md-button
                  class="md-info access-button csv_btn"
                  @click.native="downloadCSVData"
                  ><md-icon class="ml-5">receipt_long</md-icon>Download CSV
                </md-button>
              </div>
            </div>
          </div>
          <modal
            v-if="feedbackModal"
            @close="feedbackModal = false"
            class="feedback_modal"
          >
            <template slot="body">
              <button
                type="button"
                class="close_btn"
                @click="feedbackModal = false"
              >
                <md-icon>clear</md-icon>
              </button>
              <h3 class="modal-title">Have feedback on this product?</h3>
              <p>
                Enter the details below to send your feedback to our Product
                Team.
              </p>
              <form action class="form_grp">
                <div class="field_wpr">
                  <label>Leave A Feedback Note</label>
                  <textarea
                    v-model="textFeedback"
                    placeholder="Type a message"
                  ></textarea>
                  <md-button @click="sendFeedback" class="md-info md-round mt-4"
                    >Send Feedback</md-button
                  >
                  <div class="md-layout-item">
                    <md-checkbox v-model="checkBoxOption1"
                      >1 - Report An Error</md-checkbox
                    >
                    <md-checkbox v-model="checkBoxOption2" class="pl-3"
                      >2 - Suggest an Improvement</md-checkbox
                    >
                    <md-checkbox v-model="checkBoxOption3"
                      >3 - Request a Correction</md-checkbox
                    >
                    <md-checkbox v-model="checkBoxOption4"
                      >4 - Request an Update</md-checkbox
                    >
                  </div>
                </div>
              </form>
            </template>
          </modal>
        </div>
      </div>
    </div>
    <div class="md-layout" v-if="headerData && user">
      <SPIFRPDF :headerData="headerData" :user="user" ref="html2Pdf" />
    </div>
  </div>
</template>

<script>
import ratingMixin from "@/mixins/rating-mixin";
import formatData from "@/mixins/format-data";
import SPIFRPDF from "./SPIFRPDF.vue";
import { mapActions, mapState } from "vuex";

export default {
  components: {
    SPIFRPDF,
  },
  mixins: [ratingMixin, formatData],
  props: ["headerData"],

  data() {
    return {
      filtered_years: [],
      filtered_firms: [],
      filtered_PLDollarIndustry: [],
      filtered_PLPercentIndustry: [],
      filtered_PLDollarFirm: [],
      filtered_PLPercentFirm: [],
      filtered_PLDollarVariance: [],
      filtered_PLPercentVariance: [],
      filtered_BSDollarFirm: [],
      filtered_BSPercentFirm: [],
      filtered_BSDollarIndustry: [],
      filtered_BSPercentIndustry: [],
      filtered_BSDollarVariance: [],
      filtered_BSPercentVariance: [],
      filtered_CFDollarFirm: [],
      filtered_CFDollarIndustry: [],
      filtered_CFDollarVariance: [],
      filtered_PDollarFirm: [],
      filtered_PDollarIndustry: [],
      filtered_PDollarVariance: [],
      filtered_EDollarFirm: [],
      filtered_EDollarIndustry: [],
      filtered_EDollarVariance: [],
      filtered_DRDollarFirm: [],
      filtered_DRDollarIndustry: [],
      filtered_DRDollarVariance: [],
      cashflow: [],
      cashFlowFilteredData: [],
      efficiency: [],
      efficiencyFilteredData: [],
      profitability: [],
      profitabilityFilteredData: [],
      turnover: [],
      debtRiskFilteredData: [],
      changein: [],
      changeinFilteredData: [],
      worksheet: [],
      worksheetFilteredData: [],
      annualCashRatiosDolFilteredData: [],
      annualCashRatiosPercentFilteredData: [],
      multiplesTableInfo: [
        {
          id: "Low",
          name: "Q1",
        },
        {
          id: "Med",
          name: "Median",
        },
        {
          id: "High",
          name: "Q3",
        },
      ],
    };
  },
  computed: {
    ...mapState({
      auth_user: (state) => state.user,
      data: (state) => state?.user?.report?.data,
      parsedData: (state) => {
        let parsed = {};
        state.user.report.data.forEach((e, i) => {
          if (e.year) {
            parsed[e.year] = e;
          }
        });
        return parsed;
      },
      profile: (state) => state?.user?.report,
      PLtable: (state) => state?.user?.report?.data?.tables?.PL,
      BStable: (state) => state?.user?.report?.data?.tables?.BS,
      tables: (state) => state?.user?.report?.data?.tables,
      tablesInfo: (state) => state?.user?.report?.data?.tables?.ratioInfo,
      sourcesUses: (state) => state?.user?.report?.data?.sourcesUses,
      sourceYears: (state) => state?.user?.report?.data?.sourcesUses?.years,
      release_display: (state) => state?.user?.report?.data?.release_display,
      years: (state) => state?.user?.report?.data?.years,
      bznaics_code: (state) => state?.user?.report?.data?.bznaics,
      sector_name: (state) => state?.user?.report?.data?.data?.data[0]?.sector,
      industry_title: (state) =>
        state?.user?.report?.data?.data?.data[0]?.industry,
      user: (state) => state.user.user,
      sales_class: (state) => {
        return state.user.report?.data?.data?.data[0]?.sales_class;
      },
      display_area: (state) =>
        state?.user?.report?.data?.data?.data[0]?.display_area,
      multiplesA: (state) => {
        return state.user.report.data["multiples_A"]
          ? state.user.report.data["multiples_A"]
          : [];
      },
      multiplesB: (state) => {
        return state.user.report.data["multiples_B"]
          ? state.user.report.data["multiples_B"]
          : [];
      },
      multiplesC: (state) => {
        return state.user.report.data["multiples_B"]
          ? state.user.report.data["multiples_B"]
          : [];
      },
      multiplesAll: (state) => {
        return state.user.report.data["multiples_all"]
          ? state.user.report.data["multiples_all"]
          : [];
      },
    }),
    sourceTablesInfo() {
      return _.omit(this.sourcesUses, "years");
    },
    filteredProfile() {
      return Object.values(this.profile.data).filter((item) => item);
    },
    filteredData() {
      return Object.values(this.data).filter((item) => item);
    },
    actualData() {
      return this.filteredData[0]["cashflow"];
    },
  },
  mounted() {
    this.initData();
  },
  methods: {
    ...mapActions({
      registerProductExport: "tracking/registerProductExport",
    }),
    initData() {
      if (!this.profile || !this.profile.data) {
        return;
      }

      if (this.profile && this.profile.data && this.profile.data.years) {
        this.profile.data.years.forEach((e, i) => {
          this.filtered_years.push(Number(e));
        });
      }
      if (this.profile.data) {
        let firmData = Object.values(this.profile.data.data.data)
          .filter((item) => item)
          .map((item) => ({ ...item, firms: item.firms }));

        firmData.forEach((element) => {
          this.filtered_firms.push(parseFloat(element.firms));
        });
      }
      if (this.sales_class && this.sales_class.includes(",")) {
        this.sales_class_csv = this.sales_class.replace(/,/g, "");
      }
      let PLdollarFirm = this.formatTable(this.PLtable, "firm", "dollar");
      let PLpercentFirm = this.formatTable(this.PLtable, "firm", "percent");
      let PLdollarIndustry = this.formatTable(
        this.PLtable,
        "industry",
        "dollar"
      );
      let PLpercentIndustry = this.formatTable(
        this.PLtable,
        "industry",
        "percent"
      );

      PLdollarIndustry.forEach((element) => {
        if (element.name.includes(",")) {
          element.name = element.name.replace(/,/g, "");
        }
        let k = Object.values(element.dates);
        let v = [];
        k.forEach((e, i) => {
          if (typeof e === "string" && e.includes(",")) {
            e = parseFloat(e.replace(/,/g, ""));
          }
          v.push(e);
        });
        v.unshift(element.name);
        this.filtered_PLDollarIndustry.push(v);
      });
      PLpercentIndustry.forEach((element) => {
        if (element.name.includes(",")) {
          element.name = element.name.replace(/,/g, "");
        }
        let z = Object.values(element.dates);
        let v = [];
        z.forEach((item, i) => {
          if (typeof item === "string" && item.includes(",")) {
            item = parseFloat(item.replace(/,/g, ""));
          }
          v.push(item);
        });
        v.unshift(element.name);
        this.filtered_PLPercentIndustry.push(v);
      });
      PLdollarFirm.forEach((element) => {
        if (element.name.includes(",")) {
          element.name = element.name.replace(/,/g, "");
        }
        let k = Object.values(element.dates);
        let v = [];
        k.forEach((e, i) => {
          if (typeof e === "string" && e.includes(",")) {
            e = parseFloat(e.replace(/,/g, ""));
          }
          v.push(e);
        });
        v.unshift(element.name);
        this.filtered_PLDollarFirm.push(v);
      });
      PLpercentFirm.forEach((element) => {
        if (element.name.includes(",")) {
          element.name = element.name.replace(/,/g, "");
        }
        let z = Object.values(element.dates);
        let v = [];
        z.forEach((item, i) => {
          if (typeof item === "string" && item.includes(",")) {
            item = parseFloat(item.replace(/,/g, ""));
          }
          v.push(item);
        });
        v.unshift(element.name);
        this.filtered_PLPercentFirm.push(v);
      });

      let PLdollarVariance = this.formatTable(
        this.PLtable,
        "variance",
        "dollar"
      );
      let PLpercentVariance = this.formatTable(
        this.PLtable,
        "variance",
        "percent"
      );

      PLpercentVariance.forEach((element) => {
        if (element.name.includes(",")) {
          element.name = element.name.replace(/,/g, "");
        }
        let z = Object.values(element.dates);
        let v = [];
        z.forEach((item, i) => {
          if (typeof item === "string" && item.includes(",")) {
            item = parseFloat(item.replace(/,/g, ""));
          }
          v.push(item);
        });
        v.unshift(element.name);
        this.filtered_PLPercentVariance.push(v);
      });
      PLdollarVariance.forEach((element) => {
        if (element.name.includes(",")) {
          element.name = element.name.replace(/,/g, "");
        }
        let z = Object.values(element.dates);
        let v = [];
        z.forEach((item, i) => {
          if (typeof item === "string" && item.includes(",")) {
            item = parseFloat(item.replace(/,/g, ""));
          }
          v.push(item);
        });
        v.unshift(element.name);
        this.filtered_PLDollarVariance.push(v);
      });

      // ----------------------------- BS -----------------------------------

      let BSdollarFirm = this.formatTable(this.BStable, "firm", "dollar");
      let BSpercentFirm = this.formatTable(this.BStable, "firm", "percent");
      let BSdollarIndustry = this.formatTable(
        this.BStable,
        "industry",
        "dollar"
      );
      let BSpercentIndustry = this.formatTable(
        this.BStable,
        "industry",
        "percent"
      );
      let BSdollarVariance = this.formatTable(
        this.BStable,
        "variance",
        "dollar"
      );
      let BSpercentVariance = this.formatTable(
        this.BStable,
        "variance",
        "percent"
      );

      BSdollarFirm.forEach((element) => {
        if (element.name.includes(",")) {
          element.name = element.name.replace(/,/g, "");
        }
        let k = Object.values(element.dates);
        let v = [];
        k.forEach((e, i) => {
          if (typeof e === "string" && e.includes(",")) {
            e = parseFloat(e.replace(/,/g, ""));
          }
          v.push(e);
        });
        v.unshift(element.name);
        this.filtered_BSDollarFirm.push(v);
      });

      BSpercentFirm.forEach((element) => {
        if (element.name.includes(",")) {
          element.name = element.name.replace(/,/g, "");
        }
        let z = Object.values(element.dates);
        let v = [];
        z.forEach((item, i) => {
          if (typeof item === "string" && item.includes(",")) {
            item = parseFloat(item.replace(/,/g, ""));
          }
          v.push(item);
        });
        v.unshift(element.name);
        this.filtered_BSPercentFirm.push(v);
      });

      BSdollarIndustry.forEach((element) => {
        if (element.name.includes(",")) {
          element.name = element.name.replace(/,/g, "");
        }
        let k = Object.values(element.dates);
        let v = [];
        k.forEach((e, i) => {
          if (typeof e === "string" && e.includes(",")) {
            e = parseFloat(e.replace(/,/g, ""));
          }
          v.push(e);
        });
        v.unshift(element.name);
        this.filtered_BSDollarIndustry.push(v);
      });
      BSpercentIndustry.forEach((element) => {
        if (element.name.includes(",")) {
          element.name = element.name.replace(/,/g, "");
        }
        let z = Object.values(element.dates);
        let v = [];
        z.forEach((item, i) => {
          if (typeof item === "string" && item.includes(",")) {
            item = parseFloat(item.replace(/,/g, ""));
          }
          v.push(item);
        });
        v.unshift(element.name);
        this.filtered_BSPercentIndustry.push(v);
      });

      BSdollarVariance.forEach((element) => {
        if (element.name.includes(",")) {
          element.name = element.name.replace(/,/g, "");
        }
        let k = Object.values(element.dates);
        let v = [];
        k.forEach((e, i) => {
          if (typeof e === "string" && e.includes(",")) {
            e = parseFloat(e.replace(/,/g, ""));
          }
          v.push(e);
        });
        v.unshift(element.name);
        this.filtered_BSDollarVariance.push(v);
      });
      BSpercentVariance.forEach((element) => {
        if (element.name.includes(",")) {
          element.name = element.name.replace(/,/g, "");
        }
        let z = Object.values(element.dates);
        let v = [];
        z.forEach((item, i) => {
          if (typeof item === "string" && item.includes(",")) {
            item = parseFloat(item.replace(/,/g, ""));
          }
          v.push(item);
        });
        v.unshift(element.name);
        this.filtered_BSPercentVariance.push(v);
      });
      let CFtable = {
        "Net Cash turnover (X)": this.tables.ratios.cashflow[
          "Net Cash turnover (X)"
        ],
        "Net Cash/ Revenue %": this.tables.ratios.cashflow[
          "Net Cash/ Revenue %"
        ],
      };

      let CFdollarFirm = this.formatTable(CFtable, "firm");
      let CFdollarIndustry = this.formatTable(CFtable, "industry");
      let CFdollarVariance = this.formatTable(CFtable, "variance");

      CFdollarFirm.forEach(async (element) => {
        if (!element || !element.dates) {
          this.filtered_CFDollarFirm.push({});
          return;
        }
        if (element.name?.includes(",")) {
          element.name = element.name.replace(/,/g, "");
        }
        let k = Object.values(element?.dates);
        let v = [];
        await k.forEach((e, i) => {
          if (typeof e === "string" && e.includes(",")) {
            e = parseFloat(e.replace(/,/g, ""));
          }
          v.push(e);
        });
        v.unshift(element.name);
        this.filtered_CFDollarFirm.push(v);
      });
      CFdollarIndustry.forEach((element) => {
        if (element.name && element.dates) {
          if (element.name.includes(",")) {
            element.name = element.name.replace(/,/g, "");
          }
          let k = Object.values(element.dates);
          let v = [];
          k.forEach((e, i) => {
            if (typeof e === "string" && e.includes(",")) {
              e = parseFloat(e.replace(/,/g, ""));
            }
            v.push(e);
          });
          v.unshift(element.name);
          this.filtered_CFDollarIndustry.push(v);
        }
      });
      CFdollarVariance.forEach((element) => {
        if (element.name && element.dates) {
          if (element.name.includes(",")) {
            element.name = element.name.replace(/,/g, "");
          }
          let z = Object.values(element.dates);
          let v = [];
          z.forEach((item, i) => {
            if (typeof item === "string" && item.includes(",")) {
              item = parseFloat(item.replace(/,/g, ""));
            }
            v.push(item);
          });
          v.unshift(element.name);
          this.filtered_CFDollarVariance.push(v);
        }
      });

      // -------------------------- Profitability ----------------------

      let Ptable = {
        "EBITDA: Revenue": this.tables.ratios["profitability"][
          "EBITDA: Revenue"
        ],
        "Gross Profit: Revenue": this.tables.ratios["profitability"][
          "Gross Profit: Revenue"
        ],
        "Owner Earnings per Employee": this.tables.ratios["profitability"][
          "Owner Earnings per Employee"
        ],
        "Profit per Employee": this.tables.ratios["profitability"][
          "Profit per Employee"
        ],
        "Return on Revenue (%)": this.tables.ratios["profitability"][
          "Return on Revenue (%)"
        ],
      };

      let PdollarFirm = this.formatTable(Ptable, "firm");
      let PdollarIndustry = this.formatTable(Ptable, "industry");
      let PdollarVariance = this.formatTable(Ptable, "variance");

      PdollarFirm.forEach((element) => {
        if (element.name.includes(",")) {
          element.name = element.name.replace(/,/g, "");
        }
        let k = Object.values(element.dates);
        let v = [];
        k.forEach((e, i) => {
          if (typeof e === "string" && e.includes(",")) {
            e = parseFloat(e.replace(/,/g, ""));
          }
          v.push(e);
        });
        v.unshift(element.name);
        this.filtered_PDollarFirm.push(v);
      });
      PdollarIndustry.forEach((element) => {
        if (element.name.includes(",")) {
          element.name = element.name.replace(/,/g, "");
        }
        let k = Object.values(element.dates);
        let v = [];
        k.forEach((e, i) => {
          if (typeof e === "string" && e.includes(",")) {
            e = parseFloat(e.replace(/,/g, ""));
          }
          v.push(e);
        });
        v.unshift(element.name);
        this.filtered_PDollarIndustry.push(v);
      });
      PdollarVariance.forEach((element) => {
        if (element.name.includes(",")) {
          element.name = element.name.replace(/,/g, "");
        }
        let z = Object.values(element.dates);
        let v = [];
        z.forEach((item, i) => {
          if (typeof item === "string" && item.includes(",")) {
            item = parseFloat(item.replace(/,/g, ""));
          }
          v.push(item);
        });
        v.unshift(element.name);
        this.filtered_PDollarVariance.push(v);
      });

      // -------------------------- Efficiency ----------------------

      let Etable = {
        "Cost of Sales: Inventory (x)": this.tables.ratios["efficiency"][
          "Cost of Sales: Inventory (x)"
        ],
        "Inventory Turnover": this.tables.ratios["efficiency"][
          "Inventory Turnover"
        ],
        "Total Labor: Revenue": this.tables.ratios["efficiency"][
          "Total Labor: Revenue"
        ],
      };

      let EdollarFirm = this.formatTable(Etable, "firm");
      let EdollarIndustry = this.formatTable(Etable, "industry");
      let EdollarVariance = this.formatTable(Etable, "variance");

      EdollarFirm.forEach((element) => {
        if (element.name.includes(",")) {
          element.name = element.name.replace(/,/g, "");
        }
        let k = Object.values(element.dates);
        let v = [];
        k.forEach((e, i) => {
          if (typeof e === "string" && e.includes(",")) {
            e = parseFloat(e.replace(/,/g, ""));
          }
          v.push(e);
        });
        v.unshift(element.name);
        this.filtered_EDollarFirm.push(v);
      });
      EdollarIndustry.forEach((element) => {
        if (element.name.includes(",")) {
          element.name = element.name.replace(/,/g, "");
        }
        let k = Object.values(element.dates);
        let v = [];
        k.forEach((e, i) => {
          if (typeof e === "string" && e.includes(",")) {
            e = parseFloat(e.replace(/,/g, ""));
          }
          v.push(e);
        });
        v.unshift(element.name);
        this.filtered_EDollarIndustry.push(v);
      });
      EdollarVariance.forEach((element) => {
        if (element.name.includes(",")) {
          element.name = element.name.replace(/,/g, "");
        }
        let z = Object.values(element.dates);
        let v = [];
        z.forEach((item, i) => {
          if (typeof item === "string" && item.includes(",")) {
            item = parseFloat(item.replace(/,/g, ""));
          }
          v.push(item);
        });
        v.unshift(element.name);
        this.filtered_EDollarVariance.push(v);
      });

      // ------------------------- Annual Cash Ratios Dol ------------------------------

      let ACDtable = {
        "All Direct Expenses": this.tables["annual_cash_ratios_dollar"][
          "All Direct Expenses"
        ],
        "Cost of Sales": this.tables["annual_cash_ratios_dollar"][
          "Cost of Sales"
        ],
        "Gross Profit": this.tables["annual_cash_ratios_dollar"][
          "Gross Profit"
        ],
        "Net Cash": this.tables["annual_cash_ratios_dollar"]["Net Cash"],
        "Net Cash & Labor": this.tables["annual_cash_ratios_dollar"][
          "Net Cash & Labor"
        ],
        Revenue: this.tables["annual_cash_ratios_dollar"]["Revenue"],
      };

      let ACdollarIndustry = this.formatTable(ACDtable, "industry", "dollar");

      ACdollarIndustry.forEach((element) => {
        if (element.name.includes(",")) {
          element.name = element.name.replace(/,/g, "");
        }
        let k = Object.values(element.dates);
        let v = [];
        k.forEach((e, i) => {
          if (typeof e === "string" && e.includes(",")) {
            e = parseFloat(e.replace(/,/g, ""));
          }
          v.push(e);
        });
        v.unshift(element.name);
        this.annualCashRatiosDolFilteredData.push(v);
      });

      // ------------------------- Annual Cash Ratios Percent ------------------------------

      let ACPtable = {
        "Net Cash": this.tables["annual_cash_ratios_percent"]["Net Cash"],
        "Net Cash/ All Direct Expenses": this.tables[
          "annual_cash_ratios_percent"
        ]["Net Cash/ All Direct Expenses"],
        "Net Cash/ Cost of Sales": this.tables["annual_cash_ratios_percent"][
          "Net Cash/ Cost of Sales"
        ],
        "Net Cash/ Gross Profit": this.tables["annual_cash_ratios_percent"][
          "Net Cash/ Gross Profit"
        ],
        "Net Cash/ Net Cash & Labor": this.tables["annual_cash_ratios_percent"][
          "Net Cash/ Net Cash & Labor"
        ],
        "Net Cash/ Revenue": this.tables["annual_cash_ratios_percent"][
          "Net Cash/ Revenue"
        ],
      };

      let ACpercentIndustry = this.formatTable(ACPtable, "industry", "percent");

      ACpercentIndustry.forEach((element) => {
        if (element.name.includes(",")) {
          element.name = element.name.replace(/,/g, "");
        }
        let k = Object.values(element.dates);
        let v = [];
        k.forEach((e, i) => {
          if (typeof e === "string" && e.includes(",")) {
            e = parseFloat(e.replace(/,/g, ""));
          }
          v.push(e);
        });
        v.unshift(element.name);
        this.annualCashRatiosPercentFilteredData.push(v);
      });

      Object.entries(this.sourceTablesInfo).forEach(([table, data]) =>
        this.$set(this, table, this.formatSourcesData(table, data))
      );

      this.changein.forEach((element, index) => {
        let k = [];
        Object.values(element.dates).forEach((e, index) => {
          k.push(e);
        });
        k.unshift(element.title);
        this.changeinFilteredData.push(k);
      });
      this.worksheet.forEach((element, index) => {
        let k = [];
        Object.values(element.dates).forEach((e, index) => {
          k.push(e);
        });
        k.unshift(element.title);
        this.worksheetFilteredData.push(k);
      });
    },
    formatSourcesData(table, data) {
      let getDates = (id) =>
        this.sourceYears.reduce((acc, cur, index) => {
          let value = this.actualData[this.sourceYears.length - index - 1][id];

          value = isNaN(Number(value)) ? value : Number(value.toFixed(0));

          return { ...acc, [cur]: value };
        }, {});

      return data.map((item) => ({
        ...item,
        dates: getDates(item.id),
      }));
    },
    generateReport() {
      this.$refs.html2Pdf.generateReport();
      this.registerProductExport({
        userId: this.auth_user?.user?.userID,
        productId: this.$route.params.id,
        exportType: "PDF",
      });
    },
    async beforeDownload({ html2pdf, options, pdfContent }) {
      await html2pdf()
        .set(options)
        .from(pdfContent)
        .toPdf()
        .get("pdf")
        .then((pdf) => {
          if (!this.$store.getters["user/pdfMustBeDownloaded"])
            window.open(pdf.output("bloburl"), "_blank");
        });
    },
    feedback() {
      this.feedbackModal = true;
    },
    sendFeedback() {
      if (this.category) {
        let currentSession = localStorage.getItem(
          "vue-authenticate.vueauth_access_token"
        );
        axios
          .post(
            process.env.VUE_APP_API_BASE_URL + "/user/feedback/submit",
            {},
            {
              params: {
                session_id: currentSession,
                feedback: this.textFeedback,
                ip: `${this.userIP}`,
                url: `${window.location.href}`,
                category: this.category,
              },
            }
          )
          .then((res) => {
            if (res.hasOwnProperty("data") && res.data.error) {
              this.$store.commit("SET_ERROR_BIT", true);
              this.$store.commit(
                "SET_ERROR_INFO",
                "<br>" +
                  "Server responded with error = True <br> errorCode: " +
                  res.data.errorCode +
                  `<br> ${process.env.VUE_APP_API_BASE_URL} + "/user/feedback/submit" <br>`
              );
              throw new Error(
                "<br>" +
                  "Server responded with error = True <br> errorCode: " +
                  res.data.errorCode
              );
            }

            if (res.data.success)
              this.$store.dispatch("alerts/success", "Data saved.");
            else
              this.$store.dispatch(
                "alerts/error",
                "An error occured. please try again"
              );

            this.feedbackModal = false;
            this.textFeedback = null;
            this.category = null;

            this.checkBoxOption1 = false;
            this.checkBoxOption2 = false;
            this.checkBoxOption3 = false;
            this.checkBoxOption4 = false;
          });
      } else {
        this.$store.commit("SET_ERROR_BIT", true);
        this.$store.commit(
          "SET_ERROR_INFO",
          "<br>" +
            "Server responded with error = True <br> errorCode: " +
            "category_not_set" +
            `<br> ${process.env.VUE_APP_API_BASE_URL} + "/user/feedback/submit" <br>`
        );
      }
    },

    async downloadCSVData() {
      let csv = "";
      await this.initData();
      let csvData = await this.getCsvData();

      csvData.forEach((row) => {
        csv += row.join(",");
        csv += "\n";
      });
      const anchor = document.createElement("a");
      anchor.href = "data:text/csv;charset=utf-8," + encodeURIComponent(csv);
      anchor.target = "_blank";
      anchor.download = "Sole Proprietorship Report.csv";
      anchor.click();
      this.registerProductExport({
        userId: this.auth_user?.user?.userID,
        productId: this.$route.params.id,
        exportType: "CSV",
      });
    },
    async getCsvData() {
      let csvData = [
        ["Sole Proprietorship Report"],
        ['"Release Date"', this.release_display],
        [""],
        ["Segment", "Industry"],
        [""],
        [this.industry_title],
        ["[" + parseInt(this.bznaics_code) + "]" + " Sector", this.sector_name],
        ["Market", this.display_area],
        ["Sales Class", this.sales_class_csv],
        [""],
      ];

      csvData.push(["Firms Analyzed", this.filtered_years]);
      csvData.push(["", this.filtered_firms]);
      csvData.push([""]);

      let year_places = [];

      this.profile.data.years.forEach((e, i) => {
        year_places.push("");
      });

      csvData.push([
        "Income and Expense - Profit and Loss($)",
        year_places,
        "",
        this.sector_name,
        year_places,
        "Variance",
      ]);
      csvData.push([
        "",
        this.filtered_years,
        "",
        this.filtered_years,
        "",
        this.filtered_years,
      ]);

      this.filtered_PLDollarFirm.forEach((e, i) => {
        if (typeof e === "string" && e.includes(",")) {
          e = e.replace(/,/g, "");
        }
        e.push("");

        // Remove label
        this.filtered_PLDollarIndustry[i].shift();
        e = e.concat(this.filtered_PLDollarIndustry[i]);

        e.push("");
        // Remove label
        this.filtered_PLDollarVariance[i].shift();
        e = e.concat(this.filtered_PLDollarVariance[i]);
        csvData.push(e);
      });

      csvData.push([""]);

      csvData.push([
        "Income and Expense - Profit and Loss(%)",
        year_places,
        "",
        this.sector_name,
        year_places,
        "Variance",
      ]);
      csvData.push([
        "",
        this.filtered_years,
        "",
        this.filtered_years,
        "",
        this.filtered_years,
      ]);

      this.filtered_PLPercentFirm.forEach((e, i) => {
        if (typeof e === "string" && e.includes(",")) {
          e = e.replace(/,/g, "");
        }
        e.push("");

        // Remove label
        this.filtered_PLPercentIndustry[i].shift();
        e = e.concat(this.filtered_PLPercentIndustry[i]);

        e.push("");
        // Remove label
        this.filtered_PLPercentVariance[i].shift();
        e = e.concat(this.filtered_PLPercentVariance[i]);
        csvData.push(e);
      });

      // csvData.push(['']);

      // csvData.push([
      //   'Balance Sheet ($)',
      //   year_places,
      //   '',
      //   this.sector_name,
      //   year_places,
      //   'Variance',
      // ]);
      // csvData.push([
      //   '',
      //   this.filtered_years,
      //   '',
      //   this.filtered_years,
      //   '',
      //   this.filtered_years,
      // ]);

      // this.filtered_BSDollarFirm.forEach((e, i) => {
      //    if (typeof e === 'string' && e.includes(',')) {
      //     e = e.replace(/,/g, '');
      //   }
      //   e.push('');

      //   // Remove label
      //   this.filtered_BSDollarIndustry[i].shift();
      //   e = e.concat(this.filtered_BSDollarIndustry[i]);

      //   e.push('');
      //   // Remove label
      //   this.filtered_BSDollarVariance[i].shift();
      //   e = e.concat(this.filtered_BSDollarVariance[i]);
      //   csvData.push(e);
      // });

      // csvData.push(['']);

      // csvData.push([
      //   'Balance Sheet (%)',
      //   year_places,
      //   '',
      //   this.sector_name,
      //   year_places,
      //   'Variance',
      // ]);
      // csvData.push([
      //   '',
      //   this.filtered_years,
      //   '',
      //   this.filtered_years,
      //   '',
      //   this.filtered_years,
      // ]);

      // this.filtered_BSPercentFirm.forEach((e, i) => {
      //    if (typeof e === 'string' && e.includes(',')) {
      //     e = e.replace(/,/g, '');
      //   }
      //   e.push('');

      //   // Remove label
      //   this.filtered_BSPercentIndustry[i].shift();
      //   e = e.concat(this.filtered_BSPercentIndustry[i]);

      //   e.push('');
      //   // Remove label
      //   this.filtered_BSPercentVariance[i].shift();
      //   e = e.concat(this.filtered_BSPercentVariance[i]);
      //   csvData.push(e);
      // });

      csvData.push([""]);
      csvData.push([
        "Financial Ratios: Cash Flow-Solvency",
        year_places,
        "",
        this.sector_name,
        year_places,
        "Variance",
      ]);
      csvData.push([
        "",
        this.filtered_years,
        "",
        this.filtered_years,
        "",
        this.filtered_years,
      ]);

      this.filtered_CFDollarFirm.forEach((e, i) => {
        if (typeof e === "string" && e.includes(",")) {
          e = e.replace(/,/g, "");
        }
        e.push("");

        // Remove label
        this.filtered_CFDollarIndustry[i].shift();
        e = e.concat(this.filtered_CFDollarIndustry[i]);

        e.push("");
        // Remove label
        this.filtered_CFDollarVariance[i].shift();
        e = e.concat(this.filtered_CFDollarVariance[i]);
        csvData.push(e);
      });

      csvData.push([""]);
      csvData.push([""]);
      csvData.push([""]);

      csvData.push([
        "Financial Ratios: Profitability",
        year_places,
        "",
        this.sector_name,
        year_places,
        "Variance",
      ]);
      csvData.push([
        "",
        this.filtered_years,
        "",
        this.filtered_years,
        "",
        this.filtered_years,
      ]);

      this.filtered_PDollarFirm.forEach((e, i) => {
        if (typeof e === "string" && e.includes(",")) {
          e = e.replace(/,/g, "");
        }
        e.push("");

        // Remove label
        this.filtered_PDollarIndustry[i].shift();
        e = e.concat(this.filtered_PDollarIndustry[i]);

        e.push("");
        // Remove label
        this.filtered_PDollarVariance[i].shift();
        e = e.concat(this.filtered_PDollarVariance[i]);
        csvData.push(e);
      });

      csvData.push([""]);
      csvData.push([""]);
      csvData.push([""]);

      csvData.push([
        "Financial Ratios: Efficiency",
        year_places,
        "",
        this.sector_name,
        year_places,
        "Variance",
      ]);
      csvData.push([
        "",
        this.filtered_years,
        "",
        this.filtered_years,
        "",
        this.filtered_years,
      ]);

      this.filtered_EDollarFirm.forEach((e, i) => {
        if (typeof e === "string" && e.includes(",")) {
          e = e.replace(/,/g, "");
        }
        e.push("");

        // Remove label
        this.filtered_EDollarIndustry[i].shift();
        e = e.concat(this.filtered_EDollarIndustry[i]);

        e.push("");
        // Remove label
        this.filtered_EDollarVariance[i].shift();
        e = e.concat(this.filtered_EDollarVariance[i]);
        csvData.push(e);
      });

      csvData.push([""]);

      csvData.push([""]);
      csvData.push([""]);
      csvData.push(["Annual Cash Ratios ($)"]);
      csvData.push(["", this.filtered_years]);
      this.annualCashRatiosDolFilteredData.forEach((e, i) => {
        if (typeof e == "string" && e.includes(",")) {
          e = e.replace(/,/g, "");
        }
        csvData.push(e);
      });
      csvData.push([""]);
      csvData.push([""]);
      csvData.push([""]);
      csvData.push(["Annual Cash Ratios (%)"]);
      csvData.push(["", this.sourceYears]);
      this.annualCashRatiosPercentFilteredData.forEach((e, i) => {
        if (typeof e == "string" && e.includes(",")) {
          e = e.replace(/,/g, "");
        }
        csvData.push(e);
      });

      // csvData.push(['']);
      // csvData.push(['']);
      // csvData.push(['']);
      // csvData.push(['Sources & Uses of Funds']);
      // csvData.push(['', this.sourceYears]);

      // this.changeinFilteredData.forEach((e, i) => {
      //   if (typeof e == 'string' && e.includes(',')) {
      //     e = e.replace(/,/g, '');
      //   }
      //   csvData.push(e);
      // });
      // csvData.push(['Worksheet:']);
      // this.worksheetFilteredData.forEach((e, i) => {
      //   if (typeof e == 'string' && e.includes(',')) {
      //     e = e.replace(/,/g, '');
      //   }
      //   csvData.push(e);
      // });

      // ------------------- Valuation -------------------------
      csvData.push([""]);
      csvData.push([""]);
      csvData.push([""]);
      csvData.push(["Valuation Multiples"]);
      csvData.push(["Sales Group: < $2.5m:"]);
      csvData.push(["", "Sales Multiples", "Earnings Multiples"]);

      this.multiplesTableInfo.forEach((item, index) => {
        csvData.push([
          item.name,
          this.multiplesA[`Sales${item.id}`],
          this.multiplesA[`Earnings${item.id}`],
        ]);
      });

      csvData.push([""]);

      csvData.push(["Sales Group: $2.5m - $24.9m:"]);
      csvData.push(["", "Sales Multiples", "Earnings Multiples"]);

      this.multiplesTableInfo.forEach((item, index) => {
        csvData.push([
          item.name,
          this.multiplesB[`Sales${item.id}`],
          this.multiplesB[`Earnings${item.id}`],
        ]);
      });

      csvData.push([""]);

      csvData.push(["Sales Group: > $25m:"]);
      csvData.push(["", "Sales Multiples", "Earnings Multiples"]);

      this.multiplesTableInfo.forEach((item, index) => {
        csvData.push([
          item.name,
          this.multiplesC[`Sales${item.id}`],
          this.multiplesC[`Earnings${item.id}`],
        ]);
      });

      csvData.push([""]);

      csvData.push(["Sales Group: All:"]);
      csvData.push(["", "Sales Multiples", "Earnings Multiples"]);

      this.multiplesTableInfo.forEach((item, index) => {
        csvData.push([
          item.name,
          this.multiplesAll[`Sales${item.id}`],
          this.multiplesAll[`Earnings${item.id}`],
        ]);
      });

      return csvData;
    },
  },
  watch: {
    profile(newval, oldval) {
      // this.parseCSVData();
      this.initData();
    },
  },
};
</script>
<style lang="scss"></style>
